"use strict";
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var iterator_1 = require("./iterator");
var StringCases;
(function (StringCases) {
    StringCases[StringCases["unknown"] = 0] = "unknown";
    StringCases[StringCases["lowerCase"] = 1] = "lowerCase";
    StringCases[StringCases["upperCase"] = 2] = "upperCase";
    StringCases[StringCases["camelCase"] = 3] = "camelCase";
    StringCases[StringCases["pascalCase"] = 4] = "pascalCase";
    StringCases[StringCases["snakeCase"] = 5] = "snakeCase";
    StringCases[StringCases["kebabCase"] = 6] = "kebabCase";
})(StringCases = exports.StringCases || (exports.StringCases = {}));
function breakWords(text) {
    var capitalWord, cur, match;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                capitalWord = /([A-Z][a-z0-9]*)/g;
                cur = 0;
                _a.label = 1;
            case 1:
                match = capitalWord.exec(text);
                if (!match) {
                    return [3 /*break*/, 6];
                }
                if (!(match.index > cur)) return [3 /*break*/, 3];
                return [4 /*yield*/, text.substr(cur, match.index - cur)];
            case 2:
                _a.sent();
                _a.label = 3;
            case 3: return [4 /*yield*/, match[1]];
            case 4:
                _a.sent();
                cur = match.index + match[1].length;
                _a.label = 5;
            case 5: return [3 /*break*/, 1];
            case 6: return [2 /*return*/];
        }
    });
}
exports.breakWords = breakWords;
var isLowerCase = function (text) { return text && text.match(/^[a-z0-9]+$/); };
var isUpperCase = function (text) { return text && text.match(/^[A-Z0-9]+$/); };
var isWord = function (text) { return text && text.match(/^[a-zA-Z0-9]+$/); };
var isCamelCase = function (text) { return text && isWord(text) && isLowerCase(iterator_1.first(breakWords(text))); };
var isCapitalWord = function (text) { return text.match(/^[A-Z][a-z0-9]*$/); };
var isPascalCase = function (text) { return text && isWord(text) && iterator_1.asArray(breakWords(text)).filter(function (x) { return !isCapitalWord(x); }).length === 0; };
var isSnakeCase = function (text) { return text && text.indexOf('_') >= 0 && text.split('_').filter(function (x) { return !isWord(x); }).length === 0; };
var isKebabCase = function (text) { return text && text.indexOf('-') >= 0 && text.split('-').filter(function (x) { return !isWord(x); }).length === 0; };
function detectCase(name) {
    var result = StringCases.unknown;
    if (name) {
        if (isLowerCase(name)) {
            return StringCases.lowerCase;
        }
        if (isUpperCase(name)) {
            return StringCases.upperCase;
        }
        if (isCamelCase(name)) {
            return StringCases.camelCase;
        }
        if (isPascalCase(name)) {
            return StringCases.pascalCase;
        }
        if (isCamelCase(name)) {
            return StringCases.camelCase;
        }
        if (isSnakeCase(name)) {
            return StringCases.snakeCase;
        }
        if (isKebabCase(name)) {
            return StringCases.kebabCase;
        }
    }
    return result;
}
exports.detectCase = detectCase;
function capitalize(word) {
    var match = word.match(/^([a-z])[a-z0-9A-Z]*$/);
    if (!match) {
        return word;
    }
    return "" + match[1].toUpperCase() + word.substr(1);
}
exports.capitalize = capitalize;
function toCase(targetCase, text) {
    var source = detectCase(text);
    var words = [];
    if (source === targetCase) {
        return text;
    }
    switch (source) {
        case StringCases.kebabCase:
            words = text.split('-');
            break;
        case StringCases.snakeCase:
            words = text.split('_');
            break;
        case StringCases.camelCase:
        case StringCases.pascalCase:
            words = iterator_1.asArray(breakWords(text));
            break;
        default:
            words = [text];
    }
    switch (targetCase) {
        case StringCases.lowerCase:
            return words.map(function (x) { return x.toLowerCase(); }).join('');
        case StringCases.upperCase:
            return words.map(function (x) { return x.toUpperCase(); }).join('');
        case StringCases.camelCase:
            return words.map(function (x, i) { return i === 0 ? x.toLowerCase() : capitalize(x); }).join('');
        case StringCases.pascalCase:
            return words.map(function (x, i) { return i === 0 ? capitalize(x) : capitalize(x); }).join('');
        case StringCases.kebabCase:
            return words.map(function (x) { return x.toLowerCase(); }).join('-');
        case StringCases.snakeCase:
            return words.map(function (x) { return x.toLowerCase(); }).join('_');
        default:
    }
    return text;
}
exports.toCase = toCase;
exports.camelCase = function (word) { return toCase(StringCases.camelCase, word); };
exports.pascalCase = function (word) { return toCase(StringCases.pascalCase, word); };
exports.kebabCase = function (word) { return toCase(StringCases.kebabCase, word); };
//# sourceMappingURL=stringCases.js.map